import * as React from "react";
import { SidebarModel } from "./SidebarModel.js";
import {
  SidebarView,
  SidebarErrataView,
  SidebarLoaderView,
} from "./SidebarView.jsx";
export {
  Sidebar,
  SidebarModel,
  SidebarView,
  SidebarErrataView,
  SidebarLoaderView,
};
const TABLET_WIDTH = 768;
/**
 * Боковая панель.
 * @param {Object} props - Атрибуты элемента.
 * @param {BrandModel} props.brand - Модель бренда.
 * @param {Object[]} props.menu - Меню для отображения.
 * @param {JSX.Element} props.navbar - Панель с иконками сверху.
 * @param {function} onSignOut - Действие при нажатии на кнопку Выход.
 * @param {JSX.Element} props.children - Основное содержимое страницы.
 * @returns {JSX.Element} Элемент JSX.
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function Sidebar({ brand, menu, navbar, onSignOut, children }) {
  const [model, updateModel] = React.useState(
    new SidebarModel({
      brand,
      menu,
      navbar,
      onSignOut,
    })
  );
  model.onToggle = onToggle;
  model.onClickMenuItem = onClickMenuItem;
  model.onClickSubmenu = onClickSubmenu;
  React.useEffect(() => {
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  return <SidebarView sidebar={model}>{children}</SidebarView>;
  function onToggle(event) {
    event.preventDefault();
    model.is_open = !model.is_open;
    updateModel(new SidebarModel(model));
  }
  // eslint-disable-next-line no-unused-vars
  function onClickMenuItem(event) {
    // don't event.preventDefault();
    if (model.is_mobile) {
      model.is_open = false;
      updateModel(new SidebarModel(model));
    }
  }
  function onClickSubmenu() {
    if (!model.is_mobile) {
      model.is_open = true;
      updateModel(new SidebarModel(model));
    }
  }
  function onResize() {
    model.is_mobile = window.innerWidth < TABLET_WIDTH;
    model.is_open = !model.is_mobile;
    updateModel(new SidebarModel(model));
  }
}
